import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import HomePage from "@/pages/HomePage";
import ReportHeaderPage from "@/pages/ReportHeaderPage";
import DashboardPage from "@/pages/DashboardPage";
import EquipmentHoursPage from "@/pages/EquipmentHoursPage";
import MaterialMovementsPage from "@/pages/MaterialMovementsPage";
import DelaysPage from "@/pages/DelaysPage";
import SafetyQualityPage from "@/pages/SafetyQualityPage";
import ReviewSubmitPage from "@/pages/ReviewSubmitPage";
import AdminPage from "@/pages/AdminPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ViewerPage from "@/pages/ViewerPage";

function ProtectedRoute({ children, adminOnly, adminOrViewer }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/home" replace />;
  if (adminOrViewer && !["admin", "viewer"].includes(user.role)) return <Navigate to="/home" replace />;
  return children;
}

function getHomePath(role) {
  if (role === "admin") return "/admin";
  if (role === "viewer") return "/reports";
  return "/home";
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to={getHomePath(user.role)} replace /> : <LandingPage />} />
      <Route path="/login" element={user ? <Navigate to={getHomePath(user.role)} replace /> : <LoginPage />} />
      <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/report/:reportId/header" element={<ProtectedRoute><ReportHeaderPage /></ProtectedRoute>} />
      <Route path="/report/:reportId/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/report/:reportId/equipment-hours" element={<ProtectedRoute><EquipmentHoursPage /></ProtectedRoute>} />
      <Route path="/report/:reportId/material-movements" element={<ProtectedRoute><MaterialMovementsPage /></ProtectedRoute>} />
      <Route path="/report/:reportId/delays" element={<ProtectedRoute><DelaysPage /></ProtectedRoute>} />
      <Route path="/report/:reportId/safety-quality" element={<ProtectedRoute><SafetyQualityPage /></ProtectedRoute>} />
      <Route path="/report/:reportId/review" element={<ProtectedRoute><ReviewSubmitPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute adminOrViewer><AnalyticsPage /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute adminOrViewer><ViewerPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to={user ? getHomePath(user.role) : "/"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background">
          <AppRoutes />
        </div>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: '#1B2430',
              border: '1px solid hsl(215 20% 20%)',
              color: '#FFFFFF',
              fontFamily: 'Inter, system-ui, sans-serif',
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
